<template>
    <i class="iconfont" :class="fontClass"></i>
</template>

<script>
const classmap={
    home: "icon-shouye",
    success: "icon-zhengque",
    erroe: "icon-cuowu",
    close: "icon-guanbi",
    warn: "icon-jinggao",
    info: "icon-xinxi",
    blog: "icon-blog",
    code: "icon-code",
    about: "icon-about",
    weixin: "icon-weixin",
    mail: "icon-mail",
    github: "icon-github-fill",
    qq: "icon-QQ-circle-fill",
    arrowUp: "icon-shangjiantou",
    arrowDown: "icon-xiajiantou",
    empty: "icon-enpty",
    chat: "icon-liuyan",
}
export default {
    props: {
        type:{
            type: String,
            required: true,
        }
    }, 
    computed: {
        fontClass(){
            return classmap[this.type];
        }
    }
}
</script>

<style scoped>
@import "//at.alicdn.com/t/c/font_5145564_ae1qhwl35b8.css";
.iconfont{
    color:inherit;
    font-size: inherit;
}
</style>